<template>
    <van-dialog v-model:show="visible" class="py-4">
        <div class="d-flex flex-column justify-content-center align-items-center px-4 mt-2">
            <div v-if="type === 'error'" class="">
                <img src="@/static/icon-warning.svg" alt="icon" height="56" class="mb-3">
                <h5 class="text-primary font-size-18 text-center">{{ $t("esim_status_fail") }}</h5>
            </div>
            <div v-else-if="type === 'success'" class="">
                <img src="@/static/icon-success.svg" alt="icon" height="56" class="mb-3">
                <h5 class="text-success font-size-18">{{ $t("esim_status_success") }}</h5>
            </div>
            <p class="text-center">{{ message }}</p>
        </div>
        <!-- Using the correct slot for the cancel button -->
        <template #footer>
            <div class="px-4 mb-2">
                <van-button type="primary" @click="Close" class="btn btn-primary w-100 text-uppercase">{{
                    $t("esim_ok") }}</van-button>
            </div>
        </template>
    </van-dialog>
</template>

<script>
import { Dialog } from 'vant';
export default {
    components: {
        [Dialog.name]: Dialog
    },
    data() {
        return {
            visible: false,
            message: '',
            type: 'success',
            closeCallback: null
        }
    },
    methods: {
        show({ code, message, onClose }) {
            this.message = message || ''
            this.type = code === 0 ? 'success' : 'error'
            this.visible = true
            this.closeCallback = typeof onClose === 'function' ? onClose : null
        },
        Close() {
            this.visible = false
            if (this.closeCallback) {
                this.closeCallback()
                this.closeCallback = null // tránh gọi lại nhiều lần
            }
        }
    }
}
</script>

<style scoped>
.notify {
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding: 12px 20px;
    border-radius: 6px;
    color: white;
    z-index: 9999;
    font-weight: bold;
    transition: all 0.3s ease;
}

.notify.success {
    background-color: #4caf50;
}

.notify.error {
    background-color: #f44336;
}
</style>